export const extractDocumentIdFromUrl = (gsUrl: string): string => {
  const matches = gsUrl.match(/user-files\/[^/]+\/([^/.]+)\.[^.]+$/);
  return matches?.[1] || '';
};
